<script setup lang="ts">
/**
 * Placeholder for a page whose data is still loading (UX roadmap #9). It stands in for the routed page while the
 * member shell (header and sidebar) is already on screen, instead of a full-screen spinner that hid the shell too.
 * Self-contained, so it also works where no layout has rendered yet (an async layout's loading state).
 */
withDefaults( defineProps< { label?: string } >(), {
  label: 'Loading page',
} );
</script>

<template>
  <div class="flex w-full flex-col gap-4" role="status" :aria-label="label">
    <span class="sr-only">{{ label }}</span>

    <div class="flex flex-col gap-3" aria-hidden="true">
      <div class="skeleton h-8 w-1/2 max-w-sm motion-reduce:animate-none"></div>
      <div class="skeleton h-4 w-3/4 max-w-xl motion-reduce:animate-none"></div>
    </div>

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3" aria-hidden="true">
      <div v-for="card in 3" :key="card" class="skeleton h-40 w-full rounded-lg motion-reduce:animate-none"></div>
    </div>

    <div class="skeleton h-64 w-full rounded-lg motion-reduce:animate-none" aria-hidden="true"></div>
  </div>
</template>
